import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import ParticipantSingleQuestion from './participant-single-question-type';
import ParticipantMultipleQuestion from './participant-multiple-question-type';
import ParticipantRangeQuestion from './participant-range-question-type';
import ParticipantWrittenQuestion from './participant-written-question-type';
import ParticipantTextQuestion from './participant-text-question-type';
import ParticipantPreferenceQuestion from './participant-preference-question-type';
import ParticipantImageQuestion from './participant-image-question-type';
import ParticipantRankingQuestion from './participant-ranking-question-type';
import { TYPE_QUESTIONS } from './constants';

import {
  BreakLine,
} from './styles';
import ParticipantFirstClickQuestion from './participant-first-click-question-type';
import ParticipantMatrixQuestion from './participant-matrix-question-type';

export const ParticipantQuestionsComponents = (props) => {
  const {
    typeQuestion,
    question,
    index,
    surveyPageAnswer,
    totalAnswers,
  } = props;

  const questionOptionsAnswers = surveyPageAnswer && surveyPageAnswer.answers;
  const questionOptions = !_.isEmpty(surveyPageAnswer) ? surveyPageAnswer.questionOptions : _.get(question, 'questionOptions', []);
  const label = _.get(surveyPageAnswer, 'label', '');
  const leftLabel = _.get(surveyPageAnswer, 'leftLabel', '');
  const rightLabel = _.get(surveyPageAnswer, 'rightLabel', '');
  const imageUrl = _.get(surveyPageAnswer, 'imageUrl', '');

  const writtenAnswer = _.get(surveyPageAnswer, 'answerOther', '');
  const mappedAnswers = questionOptionsAnswers && _.map(questionOptionsAnswers, (answer) => answer.id);
  const rankingAnswers = _.get(surveyPageAnswer, 'rankingAnswers', '');
  const firstClickCoordinatesAnswer = _.get(surveyPageAnswer, 'firstClickCoordinates', {});

  const showLineBreaker = index !== totalAnswers - 1;
  const answersMatrix = surveyPageAnswer.answersMatrix || '{}';
  const questionId = _.get(surveyPageAnswer, 'questionId', '');

  const matrixType = _.get(surveyPageAnswer, 'matrixType', '');

  switch (typeQuestion) {
    case TYPE_QUESTIONS.WRITTEN: {
      return (
        <>
          <ParticipantWrittenQuestion
            label={label}
            index={index}
            writtenAnswer={writtenAnswer}
          />
          {showLineBreaker && (<BreakLine />)}
        </>
      );
    }
    case TYPE_QUESTIONS.RANGE: {
      return (
        <>
          <ParticipantRangeQuestion
            questionOptions={questionOptions}
            label={label}
            leftLabel={leftLabel}
            rightLabel={rightLabel}
            index={index}
            optionAnswers={mappedAnswers}
          />
          {showLineBreaker && (<BreakLine />)}
        </>
      );
    }
    case TYPE_QUESTIONS.MULTIPLE_SELECT: {
      return (
        <>
          <ParticipantMultipleQuestion
            questionOptions={questionOptions}
            label={label}
            index={index}
            optionAnswers={mappedAnswers}
            otherDescription={writtenAnswer}
          />
          {showLineBreaker && (<BreakLine />)}
        </>
      );
    }
    case TYPE_QUESTIONS.SINGLE_SELECT: {
      return (
        <>
          <ParticipantSingleQuestion
            questionOptions={questionOptions}
            label={label}
            index={index}
            optionAnswers={mappedAnswers}
            otherDescription={writtenAnswer}
          />
          {showLineBreaker && (<BreakLine />)}
        </>
      );
    }
    case TYPE_QUESTIONS.TEXT_QUESTION: {
      return (
        <>
          <ParticipantTextQuestion
            label={label}
            index={index}
          />
          {showLineBreaker && (<BreakLine />)}
        </>
      );
    }
    case TYPE_QUESTIONS.PREFERENCE: {
      return (
        <>
          <ParticipantPreferenceQuestion
            questionOptions={questionOptions}
            label={label}
            index={index}
            optionAnswers={mappedAnswers}
          />
          {showLineBreaker && (<BreakLine />)}
        </>
      );
    }
    case TYPE_QUESTIONS.IMAGE: {
      return (
        <>
          <ParticipantImageQuestion
            label={label}
            index={index}
            imageUrl={imageUrl}
          />
          {showLineBreaker && (<BreakLine />)}
        </>
      );
    }
    case TYPE_QUESTIONS.MATRIX: {
      return (
        <>
          <ParticipantMatrixQuestion
            questionOptions={questionOptions}
            label={label}
            index={index}
            matrixType={matrixType}
            optionAnswers={answersMatrix}
          />
          {showLineBreaker && (<BreakLine />)}
        </>
      );
    }
    case TYPE_QUESTIONS.RANKING: {
      return (
        <>
          <ParticipantRankingQuestion
            label={label}
            index={index}
            optionAnswers={rankingAnswers}
          />
          {showLineBreaker && (<BreakLine />)}
        </>
      );
    }
    case TYPE_QUESTIONS.FIRST_CLICK: {
      return (
        <>
          <ParticipantFirstClickQuestion
            index={index}
            label={label}
            imageUrl={imageUrl}
            firstClickCoordinatesAnswer={firstClickCoordinatesAnswer}
            questionId={questionId}
          />
          {showLineBreaker && (<BreakLine />)}
        </>
      );
    }
    default:
      return null;
  }
};

ParticipantQuestionsComponents.propTypes = {
  typeQuestion: PropTypes.string,
  question: PropTypes.shape({
    id: PropTypes.string,
  }),
  index: PropTypes.number,
  surveyPageAnswer: PropTypes.instanceOf(Object),
  totalAnswers: PropTypes.number,
};

ParticipantQuestionsComponents.defaultProps = {
  typeQuestion: '',
  question: {},
  index: null,
  surveyPageAnswer: {},
  totalAnswers: null,
};
